import { render, staticRenderFns } from "./AddCanned.vue?vue&type=template&id=0daea5f0&"
import script from "./AddCanned.vue?vue&type=script&lang=js&"
export * from "./AddCanned.vue?vue&type=script&lang=js&"
import style0 from "./AddCanned.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports